import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Building } from '@phosphor-icons/react';

export default function RegisterPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await register(email, password, name);
    setLoading(false);

    if (result.success) {
      navigate('/fleets');
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA] px-4">
      <div className="w-full max-w-md">
        <div className="bg-white border border-[#E5E7EB] rounded-sm shadow-sm p-8">
          <div className="flex items-center justify-center mb-8">
            <Building size={48} weight="duotone" className="text-[#002FA7]" />
          </div>
          <h1 className="text-2xl font-bold text-[#111827] text-center mb-2 tracking-tight">Create Account</h1>
          <p className="text-sm text-[#4B5563] text-center mb-8">Join the Crew Schedule System</p>

          {error && (
            <div data-testid="register-error" className="bg-[#FEE2E2] border border-[#FF2A2A] text-[#991B1B] px-4 py-3 rounded-sm text-sm mb-4">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} data-testid="register-form">
            <div className="mb-4">
              <label htmlFor="name" className="block text-sm font-medium text-[#111827] mb-2">
                Full Name
              </label>
              <input
                id="name"
                data-testid="register-name-input"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full px-3 py-2 border border-[#E5E7EB] rounded-sm text-sm focus:border-[#002FA7] focus:ring-1 focus:ring-[#002FA7] focus:outline-none"
                required
              />
            </div>

            <div className="mb-4">
              <label htmlFor="email" className="block text-sm font-medium text-[#111827] mb-2">
                Email Address
              </label>
              <input
                id="email"
                data-testid="register-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2 border border-[#E5E7EB] rounded-sm text-sm focus:border-[#002FA7] focus:ring-1 focus:ring-[#002FA7] focus:outline-none"
                required
              />
            </div>

            <div className="mb-6">
              <label htmlFor="password" className="block text-sm font-medium text-[#111827] mb-2">
                Password
              </label>
              <input
                id="password"
                data-testid="register-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2 border border-[#E5E7EB] rounded-sm text-sm focus:border-[#002FA7] focus:ring-1 focus:ring-[#002FA7] focus:outline-none"
                required
                minLength={6}
              />
            </div>

            <button
              type="submit"
              data-testid="register-submit-button"
              disabled={loading}
              className="w-full bg-[#002FA7] text-white px-4 py-2 rounded-sm font-medium text-sm hover:bg-[#001f7a] focus:ring-2 focus:ring-offset-2 focus:ring-[#002FA7] disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
            >
              {loading ? 'Creating Account...' : 'Create Account'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-sm text-[#4B5563]">
              Already have an account?{' '}
              <Link to="/login" className="text-[#002FA7] hover:underline font-medium" data-testid="login-link">
                Sign in here
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}